import * as React from "react";
import { useEffect, useState } from "react";
import truckIcon from "../../../../../assets/images/icons/truck.png";
import tempIcon from "../../../../../assets/images/icons/temperature.png";
import humidityIcon from "../../../../../assets/images/icons/humidity.png";
import graphIcon from "../../../../../assets/images/icons/graph.png";
import {SensorIcon} from "src/app/polar-SAAS-Components/components/Icons"
import { getKits, getProjectsForUser } from "src/services/corporateService";
import { useLocation } from "react-router-dom";
import { useNavigate } from "src/app/authentication/login-react/PolarLogin";

import { environment } from "src/environments/environment";
import { mapKitForProject,fetchMetaData } from "src/app/polar-SAAS-Components/api-helper";;
import authService from 'src/app/polar-SAAS-Components/auth-service';
import { loadGoogleMaps } from "src/services/corporateService";
import AddKitModal from "src/app/popup/AddKitModal";
import { KitData } from "src/app/polar-SAAS-Components/models-new";
import QRCode from "qrcode";
declare const google: any;
import gridIcon from "../../../../../assets/images/icons/grid.svg";
import downloadIcon from "../../../../../assets/images/icons/download.svg";
import eyeIcon from "../../../../../assets/images/icons/eye.svg";
import maximizeIcon from "../../../../../assets/images/maximize.svg";
import alertCircleIcon from "../../../../../assets/images/alert-circle.svg";
import polarLogo from "../../../../../assets/images/polar.svg";
import * as JSZip from "jszip"; 
import { saveAs } from "file-saver";
import MapIcon from "../../../../../assets/images/icons/map-pin.svg";
import useStyleClasses from "src/app/polar-SAAS-Components/style";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import ProjectService from "src/app/project/ProjectService";
import { openFullScreen, exitFullScreen } from "src/app/utils";
import EntityView from "../EntityView/EntityView";
import{ getKitsForKitUsers } from "src/app/polar-SAAS-Components/api-helper";
import ConfirmationPopup from "src/app/polar-SAAS-Components/components/ConfirmationPopup";
import * as moment from 'moment-timezone';
import {DotIcon,DoorIcon} from "src/app/polar-SAAS-Components/components/Icons";
import { greenOnline, primaryBlue } from "src/app/polar-SAAS-Components/colors";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";



interface QRModalProps {
  isOpen: boolean;
  onClose: () => void;
  kits: any[];
}

const QRModal: React.FC<QRModalProps> = ({ isOpen, onClose, kits }) => {
  const [selectedKits, setSelectedKits] = useState<number[]>([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentQrCode, setCurrentQrCode] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);

  const buildQrData = (kit: any) => {
    const rawId = kit && kit.id;
    const normalizedId =
      typeof rawId === "object"
        ? rawId.kitId || rawId.id || rawId.deviceId || ""
        : rawId;
    return JSON.stringify({ id: normalizedId });
  };


  const toggleSelection = (index: number) => {
    setSelectedKits((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const toggleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedKits(kits.map((_, index) => index));
    } else {
      setSelectedKits([]);
    }
  };

  const downloadStyledQR = async (kit: any) => {
    try {
      const canvas = document.createElement("canvas");
      const size = 300;
      canvas.width = size;
      canvas.height = 450;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      ctx.fillStyle = "#2A7CED";
      ctx.fillRect(0, 0, size, 350);

      const qrData = buildQrData(kit);

      const qrUrl = await QRCode.toDataURL(qrData, {
        width: size - 50,
        margin: 0,
        color: { dark: "#FFFFFF", light: "#00000000" },
      });

      const qrImg = new Image();
      qrImg.src = qrUrl;
      await new Promise((resolve) => {
        qrImg.onload = resolve;
      });

      const qrSize = size - 50;
      const qrX = 25;
      const qrY = 25;
      ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

      const maximizeImg = new Image();
      maximizeImg.src = maximizeIcon;
      await new Promise((resolve) => {
        maximizeImg.onload = resolve;
      });

      ctx.fillStyle = "#FFFFFF";
      ctx.font = "bold 18px Poppins";

      const iconSize = 18;
      const scanTextY = qrY + qrSize + 40;
      const scanText = "Scan Me!";

      const scanTextWidth = ctx.measureText(scanText).width;
      const totalScanWidth = iconSize + 8 + scanTextWidth;
      const scanStartX = (size - totalScanWidth) / 2;

      const iconY = scanTextY - iconSize / 2;
      ctx.drawImage(maximizeImg, scanStartX, iconY, iconSize, iconSize);

      ctx.textAlign = "left";
      ctx.fillText(scanText, scanStartX + iconSize + 8, scanTextY);

      ctx.font = "14px Poppins";
      ctx.textAlign = "center";
      ctx.fillText("Get instant access to device info", size / 2, scanTextY + 25);

      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 350, size, 100);

      const alertImg = new Image();
      alertImg.src = alertCircleIcon;
      await new Promise((resolve) => {
        alertImg.onload = resolve;
      });

      ctx.fillStyle = "#000000";
      ctx.font = "14px Poppins";

      const appTextY = 375;
      const appText = "Works best with POLAR Snapshot app";

      const appTextWidth = ctx.measureText(appText).width;
      const totalAppWidth = iconSize + 8 + appTextWidth;
      const appStartX = (size - totalAppWidth) / 2;

      const alertIconY = appTextY - iconSize / 2;
      ctx.drawImage(alertImg, appStartX, alertIconY, iconSize, iconSize);

      ctx.textAlign = "left";
      ctx.fillText(appText, appStartX + iconSize + 8, appTextY);

      const logoImg = new Image();
      logoImg.src = polarLogo;
      await new Promise((resolve) => {
        logoImg.onload = resolve;
      });

      const logoWidth = 70;
      const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
      const logoY = 395;
      ctx.drawImage(logoImg, size / 2 - logoWidth / 2, logoY, logoWidth, logoHeight);

      ctx.fillStyle = "#000000";
      ctx.font = "12px Poppins";
      ctx.textAlign = "center";
      ctx.fillText("powered by SenzMate", size / 2, logoY + logoHeight + 10);

      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.download = `${kit.name}-qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Error downloading styled QR for ${kit.name}:`, error);
      downloadQR(kit);
    }
  };

  const downloadQR = async (kit: any) => {
    try {
      const qrData = buildQrData(kit);

      const url = await QRCode.toDataURL(qrData);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${kit.name}-qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Error downloading QR for ${kit.name}:`, error);
    }
  };

  const downloadAllQR = async () => {
    setIsDownloading(true);
    try {
      const kitsToDownload = selectedKits.length > 0 ? selectedKits.map((i) => kits[i]) : kits;
      const zip = new JSZip();

      for (const kit of kitsToDownload) {
        try {
          const qrData = buildQrData(kit);

          const qrUrl = await QRCode.toDataURL(qrData, { width: 300 });

          const base64Data = qrUrl.split(",")[1];
          const byteNumbers = atob(base64Data)
            .split("")
            .map((c) => c.charCodeAt(0));
          const blob = new Blob([new Uint8Array(byteNumbers)], { type: "image/png" });
          zip.file(`${kit.name}-qr.png`, blob);
        } catch (error) {
          console.error(`Failed generating QR for ${kit.name}:`, error);
        }
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "qr-codes.zip");
    } catch (error) {
      console.error("Error creating ZIP:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const viewQR = async (kit: any) => {
    try {
      const qrData = buildQrData(kit);
      const url = await QRCode.toDataURL(qrData);
      setCurrentQrCode(url);
      setIsPreviewOpen(true);
    } catch (error) {
      console.error(`Error generating QR for ${kit.name}:`, error);
    }
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setCurrentQrCode("");
  };

  const getDownloadButtonText = () => {
    if (isDownloading) return "Downloading...";
    if (selectedKits.length === 0) return "Download All";
    return `Download Selected (${selectedKits.length})`;
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
        onClick={onClose}
      >
        <div
          style={{
            background: "white",
            borderRadius: "2px",
            maxWidth: "90%",
            maxHeight: "90%",
            width: "695px",
            height: "376px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              padding: "16px 20px",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: 600,
              fontSize: "18px",
              background: "#fff",
              zIndex: 10,
              position: "sticky",
              top: 0,
            }}
          >
            <span>QR CODES</span>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <span style={{ cursor: "pointer", fontSize: "24px", lineHeight: 1 }} onClick={onClose}>
                ×
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "10px 35px 10px 20px",
            }}
          >
            <button
              style={{
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                opacity: isDownloading ? 0.7 : 1,
              }}
              onClick={downloadAllQR}
              disabled={isDownloading}
            >
              <img src={downloadIcon} width="16" height="16" alt="Download" />
              {getDownloadButtonText()}
            </button>
          </div>

          <div style={{ padding: "20px", overflowY: "auto", flex: 1 }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "12px 16px",
                        borderBottom: "1px solid #e5e7eb",
                        backgroundColor: "#f9fafb",
                        fontWeight: 600,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedKits.length === kits.length && kits.length > 0}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "12px 16px",
                        borderBottom: "1px solid #e5e7eb",
                        backgroundColor: "#f9fafb",
                        fontWeight: 600,
                      }}
                    >
                      Kit Name
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "12px 16px",
                        borderBottom: "1px solid #e5e7eb",
                        backgroundColor: "#f9fafb",
                        fontWeight: 600,
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kits.map((kit, index) => (
                    <tr key={kit.id} style={{ backgroundColor: index % 2 === 0 ? "#F4F4F4" : "#fff" }}>
                      <td style={{ textAlign: "center", padding: "12px 16px", borderBottom: "1px solid #e5e7eb" }}>
                        <input
                          type="checkbox"
                          checked={selectedKits.includes(index)}
                          onChange={() => toggleSelection(index)}
                        />
                      </td>
                      <td style={{ textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #e5e7eb" }}>
                        {kit.name}
                      </td>
                      <td
                        style={{
                          display: "flex",
                          gap: "8px",
                          justifyContent: "center",
                          padding: "12px 16px",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <button
                          style={{
                            background: "none",
                            border: "1px solid #d1d5db",
                            borderRadius: "4px",
                            padding: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => downloadStyledQR(kit)}
                          title="Download QR"
                        >
                          <img src={downloadIcon} width="16" height="16" alt="Download" />
                        </button>
                        <button
                          style={{
                            background: "none",
                            border: "1px solid #d1d5db",
                            borderRadius: "4px",
                            padding: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => viewQR(kit)}
                          title="View QR"
                        >
                          <img src={eyeIcon} width="16" height="16" alt="View" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {isPreviewOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1001,
          }}
          onClick={closePreview}
        >
          <div
            style={{ background: "white", borderRadius: "2px", maxWidth: "400px", textAlign: "center" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: 600,
                fontSize: "18px",
              }}
            >
              QR Code
              <span style={{ cursor: "pointer", fontSize: "24px", lineHeight: 1 }} onClick={closePreview}>
                ×
              </span>
            </div>
            <div style={{ padding: "20px", textAlign: "center", backgroundColor: "#2A7CED" }}>
              <img
                src={currentQrCode}
                alt="QR Code"
                style={{ width: "250px", height: "250px", borderRadius: "10px", margin: "0 auto" }}
              />
              <div style={{ margin: "20px 0" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    marginBottom: "8px",
                    fontSize: "18px",
                    color: "white",
                  }}
                >
                  <img src={maximizeIcon} width={"18px"} />
                  Scan Me!
                </div>
                <p style={{ color: "white", fontSize: "16px" }}>Get instant access to device info</p>
              </div>
            </div>
            <div style={{ padding: "16px 20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  marginBottom: "16px",
                  fontSize: "18px",
                }}
              >
                <img src={alertCircleIcon} width={"18px"} color="white" />
                Works best with POLAR Snapshot app
              </div>
              <div style={{ marginTop: "16px" }}>
                <img src={polarLogo} alt="Logo" width={"70px"} />
                <p style={{ fontSize: "12px", marginTop: "-12px" }}>powered by SenzMate</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
  const propertyIcons = {
    'T': tempIcon,
    'H':  humidityIcon,
    "Default": SensorIcon
  
  };
const KitDashboard: React.FC = () => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [activeMenu, setActiveMenu] = React.useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [kit, setKit] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [errCreatingKit, setErrCreatingKit] = useState("");
  const [showMapModal, setShowMapModal] = useState(false);
  const [myLoc, setMyLoc] = useState<{ lat: number; lng: number } | null>(null);
  const mapRef = React.useRef<HTMLDivElement>(null);
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [editKitId, setEditKitId] = useState<string | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEntityView, setShowEntityView] = useState(false);
  const [formData, setFormData] = useState({
    name:"",
    id:"",
    description:"",
    area:"",
    item:""
  });
  const [confirmOpen,setConfirmOpen]=useState(false);
  const [kitToRemove,setKitToRemove]=useState({id:"",projectId:""});


  const location = useLocation();
      const isMobile = useIsMobile(768);
  const queryParams = new URLSearchParams(location.search);
  const selectedCorporateId = queryParams.get("corporateId");
  const selectedProjectId = queryParams.get("projectId");
  const [errors,setErrors]=useState({description:""});
 
  const projectService=new ProjectService()

  const navigate = useNavigate();

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".menu-container")) {
        setActiveMenu(null);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    loadGoogleMaps(environment.googleMapKey).catch(function (e) {
      console.error("Failed to load Google Maps", e);
    });
  }, []);

  useEffect(() => {
    const shouldLock = showMapModal || showEntityView;
    document.body.style.overflow = shouldLock ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showMapModal, showEntityView]);

  useEffect(() => {
    if (!showMapModal || !myLoc || !mapRef.current) return;
    const map = new google.maps.Map(mapRef.current, {
      center: { lat: myLoc.lat, lng: myLoc.lng },
      zoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });
    new google.maps.Marker({
      position: { lat: myLoc.lat, lng: myLoc.lng },
      map: map,
      title: "You are here",
    });
  }, [showMapModal, myLoc]);
  const handleCreateKit = async(kitData: KitData) => {
    try{
    const response=await mapKitForProject(kitData);
    console.log("New entity created:", response);
    }catch(err){
      console.log('error',err,err.response)
      setErrCreatingKit(err.response.data.message||'Error creating entity');
    }
  };
  const styleClasses=useStyleClasses();
  const hasKitEditPermissions = () => {
    return authService.isSuperAdmin()  || authService.isCorporateSAASAdmin()|| authService.isCorporateAdmin()||hasKitUser()
  }
    const hasKitDeletePermissions = () => {
    return authService.isSuperAdmin()  || authService.isCorporateSAASAdmin()
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (authService.getRole()<10000) {
        try {
        const [kitRes, projectRes] = await Promise.all([getKits(), getProjectsForUser()]);

        const kitData = kitRes && kitRes.data.content ? kitRes.data.content : [];
        const projectData = projectRes && projectRes.data.content ? projectRes.data.content : [];

        const kitToCorporateMap: { [kitId: string]: string } = {};
        const kitToProjectMap: {
                                [kitId: string]: {
                                  id: string;
                                  name: string;
                                };
                              } = {};
        projectData.forEach((project: any) => {
          const corporateId = project.corporateId;
          const projectId = project.id;
          const projectName =project.name
          const kitsInProject: string[] = project.kits || [];
          kitsInProject.forEach((kitId: string) => {
            kitToCorporateMap[kitId] = corporateId;
            kitToProjectMap[kitId] = {id:projectId,name:projectName};
          });
        });

        const enhancedKits = kitData.map((kit: any) => {


          return {
            ...kit,
            corporateId: kitToCorporateMap[kit.id] || null,
            projectId: kitToProjectMap[kit.id].id|| null,
            projectName:kitToProjectMap[kit.id].name||null
            
          };
        });

        setKit(enhancedKits);
      } catch (err) {
        console.error(" Failed to load kits", err);
      } finally {
        setLoading(false);
      }}
      else {
         try {
        const kitRes = await getKitsForKitUsers();

        const kitData = kitRes && kitRes.data.content ? kitRes.data.content : [];
        console.log("kitData",kitData);
        // const projectData = projectRes && projectRes.data.content ? projectRes.data.content : [];

        // const kitToCorporateMap: { [kitId: string]: string } = {};
        // const kitToProjectMap: { [kitId: string]: string } = {};
        // projectData.forEach((project: any) => {
        //   const corporateId = project.corporateId;
        //   const projectId = project.id;
        //   const kitsInProject: string[] = project.kits || [];
        //   kitsInProject.forEach((kitId: string) => {
        //     kitToCorporateMap[kitId] = corporateId;
        //     kitToProjectMap[kitId] = projectId;
        //   });
        // });



        setKit(kitData);
      } catch (err) {
        console.error(" Failed to load kits", err);
      } finally {
        setLoading(false);
      }
        
      }
    };

    fetchData();
  }, []);

const isDeviceOnline = (lastSeenTime, intervalMinutes) => {
  if (!lastSeenTime || !intervalMinutes) return false;

  const allowedMinutes = intervalMinutes * 3;

  const lastSeen = moment.tz(lastSeenTime, "Asia/Colombo");
  const now = moment();

  const diffMinutes = now.diff(lastSeen, "minutes");

  return diffMinutes <= allowedMinutes;
};


  const filteredKits = kit
    .filter((k) => (selectedCorporateId ? k.corporateId === selectedCorporateId : true))
    .filter((k) => (selectedProjectId ? k.projectId === selectedProjectId : true))
    .filter((kits) =>
      [
        kits.name,
        kits.description,
      ]
        .join(" ")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );

 const handleOpenEditKit=(kit)=>{
    setEditKitId(kit.id);
    setFormData({
      id: kit.corporateId || "",
      name: kit.name || "",
      description:kit.description ||"",
      area:kit.metaData&&kit.metaData.area||"",
      item:kit.metadata&& kit.metaData.item||""})
    setShowEditModal(true);
    setActiveMenu(null);
  }
  const handleNavigateProjects = (corporateId)=>{
    navigate(`/projects?corporateId=${corporateId}`);
}
  const hasKitUser=async()=>{
    const response = await fetchMetaData();
        const hasKitUser=response.data&&response.data.content && response.data.content.configuration&&response.data.content.configuration.hasKitUser;
        return hasKitUser;
  }
    const handleDeleteKit = async ( ) => {
  
      try {
        setLoading(true);
        await projectService.deleteKit(kitToRemove.projectId,kitToRemove.id);
        getKits()
        setConfirmOpen(false);
        setLoading(false);
        setActiveMenu(null);
      } catch (error) {
        console.error(" Failed to delete kit:", error);
      }
    };
  const handleSubmit=()=>{

  }
  const handleCancelEdit=()=>{
    setShowEditModal(false);
  }
  return (
    <>
      <div className="container-react">
        <div className="header">
          <div className="search-filter-section">
            <div className="search-container-react">
              <input
                type="text"
                className="search-input-react"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon-react">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.0767 3.0767C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.2664 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.2664 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z"
                    fill="#324054"
                  />
                </svg>
              </span>
            </div>
            {/* <button className="filter-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6663 2H1.33301L6.66634 8.30667V12.6667L9.33301 14V8.30667L14.6663 2Z"
                  stroke="#324054"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Filter
            </button> */}
          </div>
          <div className="button-group">
            {authService.hasEntityManagementAccess()&&<button className="generate-qr-btn" 
            disabled={filteredKits.length === 0}
            onClick={() => setIsQRModalOpen(true)}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="6" height="6" stroke="currentColor" strokeWidth="1.5" />
                <rect x="9" y="1" width="6" height="6" stroke="currentColor" strokeWidth="1.5" />
                <rect x="1" y="9" width="6" height="6" stroke="currentColor" strokeWidth="1.5" />
                <rect x="2.5" y="2.5" width="3" height="3" fill="currentColor" />
                <rect x="10.5" y="2.5" width="3" height="3" fill="currentColor" />
                <rect x="2.5" y="10.5" width="3" height="3" fill="currentColor" />
                <rect x="9" y="9" width="2" height="2" fill="currentColor" />
                <rect x="13" y="9" width="2" height="2" fill="currentColor" />
                <rect x="9" y="13" width="2" height="2" fill="currentColor" />
                <rect x="13" y="13" width="2" height="2" fill="currentColor" />
              </svg>
              {isMobile ? " " : "Generate QR Codes"}
            </button>}
            {!authService.isMobileSAASAdmin() &&authService.hasEntityManagementAccess()&&
            <button
              className="add-btn-dashboard"
              onClick={() => setShowModal(true)}
            >
              + {isMobile ? " " : "Add Entity"}
            </button>}
          </div>
        </div>

        <div className="grid-container">
          {filteredKits.length===0 ? !loading&&<div className="no-results">No entities available.</div> : (
          <div className="kits-grid">
             {
              filteredKits.map((kit, index) => (
                <div key={`${kit.id}-${index}`} className="kit-card">
                  <div  className="card-project-name" style={{fontSize:"12px"}} onClick={()=>handleNavigateProjects(kit.corporateId)}>
                    {kit.projectName} <span style={{fontSize:"16px",marginLeft:"5px"}}>  ›</span>
                  </div>
                  <div className="card-header">
                    <h3
                        className="kit-name"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    {kit.properties.length>0?<DotIcon color={isDeviceOnline(kit.lastSeen,kit.interval)?"#4CAF50":"#000000"}/>:""}
                    {kit.model.type==='TRUCK'?<img
                      src={truckIcon}
                      width="23"
                      height="18"
                      alt=""
                      style={{ display: "inline-block", verticalAlign: "middle" }}
                    />:<DoorIcon/>}
                    {kit.name}
                  </h3>

                  {/* Menu container with Map button to the LEFT of the 3-dot menu */}
                  <div className="menu-container" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {/* Map button */}
                    <button
                      className="icon-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/kit-location/${kit.projectId}/${kit.id}`);
                      }}
                      title="Location"
                      aria-label="Open device location"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 28,
                        height: 28,
                        border: "1px solid #d1d5db",
                        borderRadius: 4,
                        background: "transparent",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      <img src={MapIcon} width={16} height={16} alt="Map" />
                    </button>

                    {/* 3-dot menu */}
                    <span
                      className="menu-dots"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveMenu(activeMenu === kit.id ? null : kit.id);
                      }}
                      style={{ cursor: "pointer", padding: "4px 6px" }}
                      aria-label="Open actions"
                    >
                      ⋮
                    </span>
                    {activeMenu === kit.id && (
                      <div className="dropdown-menu">
                         {authService.hasEntityManagementAccess()&&
                        <button className="dropdown-item" onClick={() => handleOpenEditKit(kit)}>Edit</button>}
                        {/* <button className="dropdown-item">Upload Data</button> */}
                        <button
                          className="dropdown-item"
                          onClick={() => navigate(`/corporate/configurations?type=kit&id=${kit.id}`)}
                        >
                          Settings
                        </button>
                        {hasKitDeletePermissions() &&
                        <button className="dropdown-item delete" onClick={()=>{setKitToRemove(kit);setConfirmOpen(true)}}>Delete</button>}
                      </div>
                    )}
                  </div>
                </div>

              <div className="last-update">   {kit.properties.length > 0 && <span>Last Update: {kit.lastSeen}</span>}</div>

                <div className="sensors-container">
                  {kit.properties.length > 0 ?
                    kit.properties.map((property, index) => {
                      return (
                        <div className={`sensor-box ${kit.properties.length<=1?'kit-1-data':kit.properties.length===2?'kit-2-data':'kit-3-data'}`} key={index}>
                          <div className="sensor-header">
                          {propertyIcons[property.code]?<img src={propertyIcons[property.code]} alt={property.displayName} style={{ width: "12px", height: "22px" }} />:propertyIcons.Default}
                         <span className={`sensor-label ${kit.properties.length>2?'sensor-label-shrinked':''}`}>{property.displayName}</span>
                       </div>
                       <div className="sensor-value">{property.displayValue}</div>
                     </div>
                   );
                }): <span className="sensor-box">Data not received yet</span>}
                </div>

                {/* <div className="users-available">
                  {kit.usersAvailable} Users Available
                </div> */}
                
                <button className="graph-btn" 
                        onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/kit-graph/${kit.projectId}/${kit.id}/false`);
                      }}
                      disabled={kit.properties&&kit.properties.length==0}>
                  <img
                    src={graphIcon}
                    width="22"
                    height="22"
                    alt=""
                    className="sensor-icon"
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  />
                  Graph
                </button>
              </div>
            ))}
          </div>)
      }
        {showModal && (
  
        <AddKitModal
          handleClose={() => setShowModal(false)}
          onCreateKit={handleCreateKit}
          showModal={showModal}
          setShowMapModal={setShowMapModal}
          myLoc={myLoc}
          setMyLoc={setMyLoc}
          error={errCreatingKit}
          setError={setErrCreatingKit}

        />
        )}
      </div>
      </div>

      {showMapModal && myLoc && (
        <div
          className="modal-overlay"
          onClick={() => setShowMapModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(900px, 95vw)",
              background: "#fff",
              borderRadius: 4,
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "12px 16px",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <strong>My Location</strong>
              <button
                onClick={() => setShowMapModal(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 22,
                  lineHeight: 1,
                  cursor: "pointer",
                }}
                aria-label="Close"
                title="Close"
              >
                ×
              </button>
            </div>

            <div ref={mapRef} style={{ width: "100%", height: "60vh" }} />

            <div
              style={{
                padding: 12,
                borderTop: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
                fontSize: 12,
                color: "#666",
              }}
            >
              <span>
                Lat: {myLoc.lat.toFixed(6)}, Lng: {myLoc.lng.toFixed(6)}
              </span>
              <a
                href={`https://www.google.com/maps?q=${myLoc.lat},${myLoc.lng}`}
                target="_blank"
                rel="noreferrer"
                style={{ marginLeft: "auto" }}
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      )}
      <QRModal
        isOpen={isQRModalOpen}
        onClose={() => setIsQRModalOpen(false)}
        kits={filteredKits}
      />
      {showEditModal && (
          <div className="model-overlay" >
            <div className="model" onClick={(e) => e.stopPropagation()}>
              <div className="model-header">
                <h2 className="model-title">
                  EDIT ENTITY
                </h2>
                <button className="close-btn" onClick={handleCancelEdit}>
                  ×
                </button>
              </div>
              <div className="model-body">
                {/* Entity Name and Entity ID */}
                <div className="form-group" style={{  paddingBottom: "0px" }}>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="name" style={styleClasses.label}>
                      Entity Name <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter entity name here"
                      value={formData.name}
                      disabled={true}
                      style={styleClasses.input}
                   />
                  </div>
                </div>
                <div className="form-group" style={{  paddingBottom: "0px" }}>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="kitId" style={styleClasses.label}>
                      Entity Id <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="kitId"
                      name="kitId"
                      value={editKitId}
                      disabled={true}
                      style={styleClasses.input}
                    />
                  </div>
                </div>

                {/* Entity Description */}
                <div className="form-group" style={{ paddingBottom: "0" }}>
                  <label htmlFor="description" style={styleClasses.label}>
                    Entity Description <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    placeholder="Enter entity description here"
                    rows={3}
                    value={formData.description}
                    onChange={handleInputChange}
                    style={{
                      ...styleClasses.input
                    }}
                  />
                    {errors.description && <span style={styleClasses.errorText}>{errors.description}</span>}
                </div>

                


       
              </div>
              <div className="model-footer">
                <button className="ktn btn-secondary" onClick={handleCancelEdit}>
                  Cancel
                </button>
                <button className="ktn btn-primary" onClick={handleSubmit}>
                  Update Entity
                </button>
              </div>
            </div>
          </div>
        )}
      {authService.hasEntityManagementAccess()&&filteredKits.length > 0 && (
        <button
          className="floating-user-btn tooltip"
          style={{
            position: "fixed",
            right: "24px",
            bottom: "24px",
            zIndex: 2100,
          }}
          onClick={async () => {
            try {
              await openFullScreen();
            } catch (err) {
              // ignore
            }
            setShowEntityView(true);
          }}
        >
          <i
            className="fas fa-tv"
            aria-hidden="true"
            style={{ fontSize: "20px", color: "#fff" }}
          />
          <span className="tooltiptext">Display View</span>
        </button>
      )}

      <Loader isLoading={loading} fullScreen={true}/>

      {showEntityView && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#02193f",
            zIndex: 3000,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <EntityView projectId={selectedProjectId || undefined} />
          <button
            style={{
              position: "fixed",
              right: "24px",
              bottom: "24px",
              zIndex: 3050,
              padding: "10px 16px",
              borderRadius: "999px",
              border: "none",
              background: "#e5e7eb",
              color: "#0f172a",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 10px 24px rgba(0,0,0,0.2)",
            }}
            onClick={() => {
              exitFullScreen();
              setShowEntityView(false);
            }}
          >
            Exit
          </button>
        </div>
      )}
       <ConfirmationPopup 
              open={confirmOpen}
              message={`Are you sure you want to delete this Kit - ${kitToRemove.id}?`}
              confirmText="Delete"
              cancelText="Cancel"
              onConfirm={handleDeleteKit}
              onCancel={() => setConfirmOpen(false)}
              isDanger={true} />
    </>
  );
};

export default KitDashboard;
